export const capitalizeFirstLetter = (text: string) => {
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

export const isEmptyString = (text: string) => text.length === 0;

export const capitalizeEachWord = (words: string) => words.split(' ').map(capitalizeFirstLetter).join(' ');

export const capitalizeEachWordArrayAndAddComma = (words: string[]) => {
  const capitalizedWords = words.map((x) => x.split(' ').map(capitalizeFirstLetter).join(' '));

  return capitalizedWords.join(',  ');
};

export const kebabCase = (string) =>
  string
    ?.replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase() ?? '';
